
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  resetPasswordButton: {
    id: "ResetPassword.button",
    defaultMessage: "Back to Login",
  },
  changePwOldLabel: {
    id: "ChangePwOld.label",
    defaultMessage: "Old Password",
  },
  changePwOldPlaceholder: {
    id: "ChangePwOld.placeholder",
    defaultMessage: "Old Password",
  },
  changePwOldError: {
    id: "ChangePwOld.error",
    defaultMessage: "The password must meet at least 2 out of 3 of the following conditions: Letters (eg ABCD ...) - Numbers (eg 0123 ...) - Special characters (eg # $% ...)",
  },
  changePwNewLabel: {
    id: "ChangePwNew.label",
    defaultMessage: "New Password",
  },
  changePwNewError: {
    id: "ChangePwNew.error",
    defaultMessage: "The password must meet at least 2 out of 3 of the following conditions: Letters (eg ABCD ...) - Numbers (eg 0123 ...) - Special characters (eg # $% ...)",
  },
  changePwNewPlaceholder: {
    id: "ChangePwNew.placeholder",
    defaultMessage: "New Password",
  },
  changePwNewRepeatLabel: {
    id: "ChangePwNewRepeat.label",
    defaultMessage: "Repeat password",
  },
  changePwNewRepeatError: {
    id: "ChangePwNewRepeat.error",
    defaultMessage: "Passwords doesn\'t match.",
  },
  changePwNewRepeatPlaceholder: {
    id: "ChangePwNewRepeat.placeholder",
    defaultMessage: "Repeat password",
  },
});

export default MESSAGES;